module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.trigger) ? _c('div', [_c('ul', {
    staticClass: "autocomplete-wrapper",
    class: _vm.heightClass,
    style: (_vm.searchListWidth && _vm.searchListWidth > 0 ? ("width: " + _vm.searchListWidth + "px;transition: width .55s ease;") : '')
  }, [_vm._l((_vm.categories), function(value) {
    return [(value.list && value.list.length) ? _c('li', {
      staticClass: "autcomplete-headers"
    }, [_vm._v(_vm._s(value.name))]) : _vm._e(), _vm._v(" "), _vm._l((value.list), function(autoSuggestedList) {
      return _c('li', {
        key: value.list,
        staticClass: "autocomplete-result",
        class: _vm.isSearchHistory ? 'd-flex pl-1 align-items-center' : ''
      }, [(_vm.isSearchHistory) ? _c('div', {
        staticClass: "d-flex"
      }, [_c('svg', {
        attrs: {
          "xmlns": "http://www.w3.org/2000/svg",
          "version": "1.0",
          "width": "20pt",
          "height": "20pt",
          "viewBox": "0 0 100.000000 100.000000",
          "preserveAspectRatio": "xMidYMid meet"
        }
      }, [_c('g', {
        attrs: {
          "transform": "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
          "fill": "#C9C7C7",
          "stroke": "#C9C7C7"
        }
      }, [_c('path', {
        attrs: {
          "d": "M385 729 c-22 -11 -54 -34 -72 -51 l-33 -32 0 26 c0 18 -7 29 -20 33 -33 11 -40 -3 -40 -80 0 -83 2 -85 85 -85 34 0 57 5 65 15 18 22 5 45 -26 45 -26 0 -26 0 12 35 93 85 201 87 283 4 84 -83 81 -205 -7 -286 -74 -68 -185 -70 -261 -4 -29 25 -54 24 -59 -2 -9 -48 86 -97 187 -97 155 0 251 95 251 249 0 110 -46 188 -135 230 -60 28 -173 29 -230 0z"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M474 637 c-2 -8 -4 -46 -2 -86 l3 -72 64 -35 c69 -37 96 -40 96 -9 0 13 -18 29 -52 50 l-52 30 -3 65 c-3 59 -5 65 -26 68 -12 2 -24 -3 -28 -11z"
        }
      })])])]) : _vm._e(), _vm._v(" "), _c('p', {
        staticClass: "autocomplete-list text-capitalize",
        on: {
          "click": function($event) {
            _vm.handleDemo(autoSuggestedList.autosuggest, autoSuggestedList.uniqueId)
          }
        }
      }, [(autoSuggestedList.imageUrl && !autoSuggestedList.imageUrl[0].includes('gif')) ? _c('img', {
        staticClass: "popular-product-imgs",
        staticStyle: {
          "width": "33px"
        },
        attrs: {
          "src": _vm.autosuggestpath + _vm.path + (autoSuggestedList.imageUrl && autoSuggestedList.imageUrl[0]) + '?w=33',
          "alt": autoSuggestedList.autosuggest
        }
      }) : (autoSuggestedList.imageUrl && autoSuggestedList.imageUrl[0].includes('gif')) ? _c('img', {
        staticClass: "popular-product-imgs",
        staticStyle: {
          "width": "33px"
        },
        attrs: {
          "src": _vm.autosuggestpath + _vm.path + (autoSuggestedList.imageUrl && autoSuggestedList.imageUrl[0]) + '?w=33',
          "alt": autoSuggestedList.autosuggest
        }
      }) : _vm._e(), _vm._v(" "), (!autoSuggestedList.imageUrl && autoSuggestedList.doctype === 'TOP_SEARCH_QUERIES') ? _c('img', {
        staticClass: "other-category-imgs",
        attrs: {
          "src": _vm.getCategoryWiseImage(autoSuggestedList.doctype),
          "alt": autoSuggestedList.autosuggest
        }
      }) : _vm._e(), _vm._v("\n            " + _vm._s(autoSuggestedList.autosuggest.replace(/[^a-zA-Z0-9]/g, " ")) + "\n          ")])])
    })]
  }), _vm._v(" "), [(_vm.isShowNewArrivalProduct && _vm.autoSuggestRecomProduct && _vm.autoSuggestRecomProduct.new_arrival_products) ? _c('li', [_c('span', {
    staticClass: "autcomplete-headers autcomplete-headers-test"
  }, [_vm._v("New Launches")]), _vm._v(" "), _c('ul', {
    staticClass: "p-0"
  }, _vm._l((_vm.autoSuggestRecomProduct.new_arrival_products), function(product, key) {
    return _c('li', {
      key: key,
      staticClass: "autocomplete-result"
    }, [_c('router-link', {
      attrs: {
        "to": '/product/' + product.product_slug
      }
    }, [_c('p', {
      staticClass: "autocomplete-list text-capitalize"
    }, [(product.images && product.images[0]) ? _c('img', {
      staticClass: "popular-product-imgs",
      staticStyle: {
        "width": "33px"
      },
      attrs: {
        "src": _vm.autosuggestpath + _vm.path + (product.images && product.images[0]) + '?w=33',
        "alt": product.product
      }
    }) : _vm._e(), _vm._v("\n                              " + _vm._s(product.product) + "\n                          ")])])], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.isShowTopSellProduct && _vm.autoSuggestRecomProduct && _vm.autoSuggestRecomProduct.top_selling_products) ? _c('li', [_c('span', {
    staticClass: "autcomplete-headers autcomplete-headers-test"
  }, [_vm._v("Trending Products")]), _vm._v(" "), _c('ul', {
    staticClass: "p-0"
  }, _vm._l((_vm.autoSuggestRecomProduct.top_selling_products), function(product, key) {
    return _c('li', {
      key: key,
      staticClass: "autocomplete-result"
    }, [_c('router-link', {
      attrs: {
        "to": '/product/' + product.product_slug
      }
    }, [_c('p', {
      staticClass: "autocomplete-list text-capitalize"
    }, [(product.images && product.images[0]) ? _c('img', {
      staticClass: "popular-product-imgs",
      staticStyle: {
        "width": "33px"
      },
      attrs: {
        "src": _vm.autosuggestpath + _vm.path + (product.images && product.images[0]) + '?w=33',
        "alt": product.product
      }
    }) : _vm._e(), _vm._v("\n                              " + _vm._s(product.product) + "\n                          ")])])], 1)
  }))]) : _vm._e()]], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02bcbb38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/autoCompleteList.vue
// module id = 1618
// module chunks = 0 18